import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { requestGetProductLifetimeStats } from "./getProductLifetimeStats.request";
import {
  ProductLifetimeStatsRequestParams,
  ProductLifetimeStatsResponse
} from "./getProductLifetimeStats.types";

const useGetProductLifetimeStats = (
  productId: string,
  params: ProductLifetimeStatsRequestParams,
  options?: QueryOptions<ProductLifetimeStatsResponse, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["products", "lifetime-stats", productId, params],
    queryFn: async () => await requestGetProductLifetimeStats(productId, params),
    enabled: !!productId,
    ...options
  });

  return { stats: data, ...rest };
};

export default useGetProductLifetimeStats;
